import { clientFetch, appendLanguageOptionParam, appendFeatureAndExperimentParams } from "@flights/client-fetch";
import { carrierUtils } from "@flights/web-api-utils-universal";
function buildBrandedFareUrl(offerToken, carriers, selectedFareName, selectedFareTravellerPrice) {
    const params = new URLSearchParams();
    carriers.forEach((carrier) => params.append("airlines[]", carrier));
    if (selectedFareName) {
        params.append("selectedFareName", selectedFareName);
    }
    if (selectedFareTravellerPrice) {
        params.append("selectedFareTravellerPrice", selectedFareTravellerPrice);
    }
    return appendFeatureAndExperimentParams(appendLanguageOptionParam(`/api/brandedFares/${offerToken}?${params.toString()}`));
}
async function fetchSingleBrandedFare(offer, selectedFareName, selectedFareTravellerPrice) {
    const carriers = carrierUtils.getUniqueMarketingCarrierCodes(offer.segments);
    const url = buildBrandedFareUrl(offer.token, carriers, selectedFareName, selectedFareTravellerPrice);
    const res = await clientFetch(url);
    return { brandedFares: res.brandedFares };
}
export async function fetchAndFilterByBrandedFares(offers, options) {
    const timeoutMs = options?.timeoutMs ?? 15000;
    const selectedFareName = options?.selectedFareName;
    const selectedFareTravellerPrice = options?.selectedFareTravellerPrice;
    const brandedFaresMap = new Map();
    const offersNeedingFetch = offers.filter((o) => o.requestableBrandedFares && (!o.brandedFareOffers || o.brandedFareOffers.length === 0));
    const fetchPromises = offersNeedingFetch.map((offer) => fetchSingleBrandedFare(offer, selectedFareName, selectedFareTravellerPrice));
    const timeoutPromise = new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), timeoutMs));
    const results = await Promise.race([Promise.allSettled(fetchPromises), timeoutPromise]).catch(() => offersNeedingFetch.map(() => ({ status: "rejected", reason: "timeout" })));
    results.forEach((result, i) => {
        if (result.status === "fulfilled") {
            brandedFaresMap.set(offersNeedingFetch[i].token, result.value);
        }
    });
    const filteredOffers = offers.map((offer) => {
        if (offer.brandedFareOffers && offer.brandedFareOffers.length > 0) {
            return { ...offer, isHidden: false };
        }
        const fetched = brandedFaresMap.get(offer.token);
        if (fetched) {
            return { ...offer, isHidden: false };
        }
        return { ...offer, isHidden: true };
    });
    return { filteredOffers, brandedFaresMap };
}
